import { useCallback, useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { CodesFilters, rangeDates } from "@/components/sms/CodesFilters";
import { CodesTable } from "@/components/sms/CodesTable";
import { CopyBar } from "@/components/sms/CopyBar";
import { PasteDialog } from "@/components/sms/PasteDialog";

export const CodesTab = ({ counts, tick, onChanged }) => {
  const [f, setF] = useState({ range: "today", from: "", to: "", status: "all", q: "" });
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ rows: [], total: 0, pages: 1, limit: 100 });
  const [pasteOpen, setPasteOpen] = useState(false);
  const [from_date, to_date] = rangeDates(f.range, f.from, f.to);
  const filters = { from_date, to_date, q: f.q, status: f.status };
  const key = JSON.stringify(filters);

  const load = useCallback(() => {
    api.get("/sms/codes", { params: { ...JSON.parse(key), page, limit: 100 } }).then(({ data: d }) => setData(d)).catch(() => {});
  }, [key, page]);
  useEffect(() => { load(); }, [load, tick]);
  const set = (p) => { setF((o) => ({ ...o, ...p })); setPage(1); };
  const refresh = () => { load(); onChanged(); };

  return (
    <div className="space-y-4">
      <CodesFilters f={f} set={set} />
      <CopyBar filters={filters} counts={{ ...counts, shown: data.total }} onCopied={refresh} onPaste={() => setPasteOpen(true)} />
      <div className="bg-white border border-[#E0DFD6] rounded-xl p-3 sm:p-4">
        <div className="flex items-center justify-between mb-2 text-xs text-[#6B6B61]">
          <span data-testid="sms-codes-total"><b className="text-[#1C1C19] tabular-nums">{data.total.toLocaleString("en-IN")}</b> codes</span>
          <span className="flex items-center gap-1">
            <button onClick={() => setPage((p) => p - 1)} disabled={page <= 1} className="p-1 rounded hover:bg-[#EFEEE6] disabled:opacity-30" data-testid="sms-page-prev" aria-label="Previous"><ChevronLeft className="w-4 h-4" /></button>
            <span className="tabular-nums" data-testid="sms-page-label">{page} / {data.pages}</span>
            <button onClick={() => setPage((p) => p + 1)} disabled={page >= data.pages} className="p-1 rounded hover:bg-[#EFEEE6] disabled:opacity-30" data-testid="sms-page-next" aria-label="Next"><ChevronRight className="w-4 h-4" /></button>
          </span>
        </div>
        <CodesTable rows={data.rows} page={data.page || page} limit={data.limit} />
      </div>
      <PasteDialog open={pasteOpen} onClose={() => setPasteOpen(false)} onSaved={refresh} />
    </div>
  );
};
